import { useTheme } from '../../../../hooks/use-theme/use-theme';
import FillCheckBox from '@bringg/react-components/dist/components/checkbox/fill-checkbox/fill-checkbox'; // TODO: change when tree shaking is fixed
import { h } from 'preact';
import { Attributes } from '../rating-form';
import { getTranslationText } from '../../../../components/translate/translate';

const textMaxLength = 150;

interface AttributeBoxProps {
	rating: number;
	goodRatingThreshold: number;
	setAttributes: (attributes: Attributes) => void;
	attributes: Attributes;
	ratingNegativeTitle?: string;
	ratingPositiveTitle?: string;
	allowFreeTextComment?: boolean;
	setComment: (string) => void;
	comment: string;
}

const AttributeBox = ({
	rating,
	goodRatingThreshold,
	setAttributes,
	attributes,
	ratingNegativeTitle,
	ratingPositiveTitle,
	allowFreeTextComment,
	setComment,
	comment
}: AttributeBoxProps) => {
	const { primaryColor } = useTheme();
	const isPositiveRating = rating > goodRatingThreshold;
	const ratingTitle = isPositiveRating ? ratingPositiveTitle || '' : ratingNegativeTitle || '';
	const shouldShowAttributes = rating > 0 && attributes.size > 0 && ratingTitle;

	const onCheck = attributeId => isChecked => {
		attributes.set(attributeId, { ...attributes.get(attributeId), isChecked });
		setAttributes(new Map(attributes));
	};

	const onCommentChange = e => {
		limitTextUnsupportedBrowswers(e);
		setComment(e.target.value);
	};

	const limitTextUnsupportedBrowswers = e => {
		e.target.value = e.target.value.substring(0, textMaxLength);
	};

	return (
		<div className="attributes-box">
			{shouldShowAttributes && (
				<div className="attributes-box-content">
					<div className="attributes-box-title">{ratingTitle}</div>
					<div className="attributes-options">
						{Array.from(attributes).map(([id, { isChecked, value }]) => (
							<FillCheckBox
								key={id}
								isChecked={isChecked}
								className="checkbox"
								color={primaryColor}
								onClick={onCheck(id)}
							>
								{value}
							</FillCheckBox>
						))}
					</div>
				</div>
			)}
			{rating && allowFreeTextComment && (
				<div className="free-text-comment">
					<textarea
						className="comment"
						maxLength={textMaxLength}
						onChange={onCommentChange}
						placeholder={getTranslationText('RATING.FREE_TEXT_COMMENT')}
					/>
					<span className="comment-count">{`${comment?.length || 0} / ${textMaxLength}`}</span>
				</div>
			)}
		</div>
	);
};

export default AttributeBox;
